module.exports = __webpack_public_path__ + "img/payu.e6ad4434.png";